var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BackhaulSubscriberSummary.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2ee8e5df\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BackhaulSubscriberSummary.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/backhaul/BackhaulSubscriberSummary.vue
// module id = 1140
// module chunks = 0